<template>
	<div class="session-page-container page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-skeleton-loader v-if="this.isLoading && !this.session" v-bind="attrs" type="card" />

			<Session v-else :session="this.session" />
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Session from '@/components/Event/Session'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'SessionPage',
	mixins: [Block, Dwh],
	components: {
		Session,
		PageBlocked,
	},
	data() {
		return {
			attrs: {
				elevation: 0,
			},
			pageBlockedName: 'events',
		}
	},
	computed: {
		...mapGetters('event', ['event', 'isLoading', 'session']),
	},
	methods: {
		...mapActions('event', ['getEvent', 'getSession', 'clearSession']),
		...mapActions('advertisement', ['getBanner', 'clearBanner']),
		...mapActions('app', ['setPageTitle']),
	},
	watch: {
		session(newValue, oldValue) {
			if (newValue && !oldValue) {
				this.sendTrigger({
					category: 'Content',
					action: 'view_session_details',
					module: 'Events',
					data: newValue.events_agenda_id,
					content_chapter_id:
						this.event && this.event.chapter_id ? [this.event.chapter_id] : null,
				})
			}
		},
	},
	mounted() {
		this.setPageTitle('Agenda')
	},
	created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
			this.getSession(this.$route.params.id)
			this.getBanner({
				places: ['event_session'],
				place_sub_id: this.$route.params.id,
			})
		}
	},
	beforeDestroy() {
		this.setPageTitle('')
		this.clearSession()
	},
}
</script>

<style lang="scss">
.session-page-container {
	max-width: 600px;
	width: 100%;
}
.post-page {
	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}
</style>
